import React, { createContext, useState, useEffect } from 'react';
import { isLocalEnvironment } from '../utils/environmentUtils';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [isLocalEnv, setIsLocalEnv] = useState(false);

    // Check environment on component mount
    useEffect(() => {
        const localEnv = isLocalEnvironment();
        setIsLocalEnv(localEnv);
        
        // If not in local environment, ensure user is logged out
        if (!localEnv) {
            setIsAuthenticated(false);
        }
    }, []);

    const login = () => {
        // Only allow login if in local environment
        if (isLocalEnv) {
            setIsAuthenticated(true);
            return true;
        }
        return false;
    };
    
    const logout = () => setIsAuthenticated(false);

    return (
        <AuthContext.Provider value={{ isAuthenticated, login, logout, isLocalEnv }}>
            {children}
        </AuthContext.Provider>
    );
};

export default AuthContext;
